import styled from "styled-components";
import {SideMenuItemsContainerDefaultBox} from "./side-menu-item-container.default.box";

export const SideMenuItemsListCasino777Box = styled(SideMenuItemsContainerDefaultBox)`
    &::before {
        box-shadow: 0px 0.25px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
    }
`;
